export interface Credential {
  key: string;
  userName: string;
  password: string;
  roles: string[];
}

export class CredentialBeingCreated {
  readonly userName: string;
  readonly password: string;
  readonly roles: string[];

  constructor(userName: string, password: string, roles: string[]) {
    this.userName = userName;
    this.password = password;
    this.roles = roles;
  }
}

export const basicCredential = new CredentialBeingCreated(
  "username",
  "password",
  []
);

interface CredentialsState {
  credentials: Credential[];
}

export const initialState: CredentialsState = {
  credentials: [],
};

export const credentialToRow = (c: Credential) => {
  return {
    key: c.userName,
    user: c.userName,
    roles: c.roles.toString(),
  };
};
